<div class="chatbot-window" *ngIf="isOpen" role="dialog" aria-label="Chat">
  <div class="chatbot-header">
    <span>Chat Assistant</span>
    <button type="button" class="chatbot-close" aria-label="Close chat" (click)="toggle()">&times;</button>
  </div>
  <div class="chatbot-body">
    <div class="chatbot-loading" *ngIf="!loaded">Loading...</div>
    <iframe *ngIf="chatSrc" [src]="chatSrc" title="Chat Assistant" (load)="loaded = true"></iframe>
  </div>
</div>

<button type="button" class="chatbot-fab" [attr.aria-label]="isOpen ? 'Close chat' : 'Open chat'" (click)="toggle()">
  <svg *ngIf="!isOpen" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="#fff">
    <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/>
  </svg>
  <svg *ngIf="isOpen" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="#fff">
    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
</button>
